import { normalizeUrl } from './url';
import { isDefined } from './utils';

export function get (url, data, config) {
  config = config || {};
  config.method = 'GET';
  return send(url, data, config);
}

export function put (url, data, config) {
  config = config || {};
  config.method = 'PUT';
  return send(url, data, config);
}

export function post (url, data, config) {
  config = config || {};
  config.method = 'POST';
  return send(url, data, config);
}

export function del (url, data, config) {
  config = config || {};
  config.method = 'DELETE';
  return send(url, data, config);
}

export function send (url, data = {}, config) {
  const deferred = $.Deferred();

  data = isDefined(data) ? data : {};
  url = normalizeUrl(url);
  config = config || {};
  config.dataType = config.dataType || 'json';
  config.contentType = typeof config.contentType !== 'undefined' ? config.contentType : 'application/x-www-form-urlencoded; charset=UTF-8';
  config.doInBackground = !!config.doInBackground;
  config.supressNotifications = !!config.supressNotifications;
  config.keepOriginalResponse = !!config.keepOriginalResponse;
  config.headers = config.headers || { 'Accept-Language': App.language };

  data.templateEvent = App.templateEvent;
  config.data = data;

  const request = $.ajax(url, config)
    .done(function (response) {
      if (config.keepOriginalResponse) {
        deferred.resolve(response);
      } else {
        deferred.resolve(response.data || response);
      }
    })
    .fail(function (jqXHR) {
      const response = jqXHR.responseText ? $.parseJSON(jqXHR.responseText) : {};

      deferred.reject(response, jqXHR.status);
    });

  deferred.abort = request.abort;

  return deferred;
}

export default { get, put, post, del, send };
